export default __webpack_public_path__ + "static/media/images.0dc55996.gif";